export default {
  diffusionInputs: 'Diffusion Inputs',
  partParameters: 'Part parameters',
  simulationValues: 'Simulation values',
};
